import {
    ApolloClient,
    InMemoryCache,
    createHttpLink,
} from "@apollo/client/core";
import { setContext } from "@apollo/client/link/context";
import { WORKFLOW_API } from "@/config";

const httpLink = createHttpLink({
  uri: `${WORKFLOW_API}/graphql`,
});

const getUserToken = () => {
  const userData = sessionStorage.getItem("userLogin");
  if (!userData) {
    return null;
  }

  try {
    const parsedUser = JSON.parse(userData);
    return parsedUser?.token || null;
  } catch (error) {
    return null;
  }
};

const authLink = setContext((_, { headers }) => {
  const token = getUserToken();
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const cache = new InMemoryCache();

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
});

export { apolloClient };
